import { useTranslation } from 'react-i18next';

import { IntegrationsIcon } from '@/features/integrations/components/integrations-icon';
import { ZapierLogo } from '@/features/integrations/components/zapier-logo';
import { Gradients } from '@/shared/components/theme/gradient';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/shared/components/ui/hover-card';
import { cn } from '@/shared/utils/cn';

export const IntegrationHoverOverlay = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { t } = useTranslation('integrations', {
    keyPrefix: 'TrackingReportIntegration',
  });

  return (
    <HoverCard>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        className={cn(
          'w-fit min-w-[280px] rounded-lg border-[0.5px] border-white/10 bg-[hsl(249_23%_16%_/_0.95)] p-0 backdrop-blur-[30px]',
        )}
        sideOffset={8}
        align="start"
        alignOffset={0}
      >
        <div
          className={cn(
            'flex flex-col border-white/15 bg-gradient-to-br',
            Gradients.dropdownGradient,
          )}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-[14px] pt-2">
            <span className="text-2xs text-white">{t('title')}</span>
            <IntegrationsIcon variant="orange" />
          </div>

          {/* Divider */}
          <div className="my-2 h-px w-full bg-white/30" />

          {/* Content */}
          <div className="flex flex-col items-center gap-4 px-5 pb-5">
            {/* Zapier Logo */}
            <ZapierLogo />

            {/* Description */}
            <p className="text-center text-2xs text-custom-medium-grey">
              {t('description')}
            </p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
